import styled from 'styled-components';

export const Wrapper = styled.div`
  i {
    font-size: var(--fontBig);
    color: gold;
  }

  .info {
    color: grey;
  }
`;
